<style lang="less" scoped>
.to-top-btn {
  height: 49px;
  width: 49px;
  position: fixed;
  bottom: 54px;
  right: 10px;
}
</style>
<template>
  <img
    ref="toTopBtn"
    class="to-top-btn"
    @click="toTop"
    v-show="showToTopButton"
    src="../../image/home/toTop.png"
  />
</template>
<script>
export default {
  data() {
    return {
      showToTopButton: false
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      if (!this.$refs.toTopBtn) {
        return window.removeEventListener("scroll", this.handleScroll);
      }
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop >= window.innerHeight) {
        this.showToTopButton = true;
        return;
      }
      this.showToTopButton = false;
    },
    toTop() {
      this.AnimationForBackTop();
      this.showToTopButton = false;
    },
    AnimationForBackTop() {
      let node_doc = document.documentElement;
      let node_body = document.body;
      let timer;
      if (timer) {
        clearInterval(timer);
      }else{
         timer = setInterval(() => {
          node_doc.scrollTop -= Math.ceil(
            (node_doc.scrollTop + node_body.scrollTop) * 0.05
          );
          node_body.scrollTop -= Math.ceil(
            (node_doc.scrollTop + node_body.scrollTop) * 0.05
          );
          if (node_body.scrollTop + node_doc.scrollTop == 0) {
            clearInterval(timer);
          }
        }, 10);
      }
    }
  }
};
</script>


